<template lang="pug">
v-row.justify-center
  v-input.d-none(
    :value="model"
    :rules="rules")
  v-file-input.d-none(
    ref="input"
    accept="image/*"
    @change="onChange")
  template(v-if="model")
    v-col.text-center(:cols="12")
        feature-avatar.mx-auto(
          :style="rounded ? `border-radius: ${Math.max(imageWidth, imageHeight)}px` : undefined"
          :src="model"
          :tile="imageWidth !== imageHeight"
          contain
          :width="imageWidth || imageHeight * (16 / 9)"
          :height="imageHeight")
    v-col.text-center.pt-0(:cols="12")
      v-btn(
        v-if="model"
        text
        @click="inputImage") Modifier
      v-btn(
        v-if="model && !hideDelete"
        text
        @click="model = null") Supprimer
  template(v-else)
    v-col(:cols="12")
      v-responsive.mx-auto(
        :width="imageWidth"
        :aspect-ratio="imageWidth ? imageWidth / imageHeight : 16 / 9")
        div.mx-auto.d-flex.justify-center.align-center.flex-column(
          v-shared-element:image-input
          @click="inputImage"
          :style="imagePlaceholderStyle")
          span.grey--text.mb-2 {{ label }}
          v-icon {{ mdiImagePlus }}
    v-col.error--text.text-center.pt-0(:cols="12")
      span(v-if="error") {{ error }}
</template>

<script>
import { mdiImagePlus } from '@mdi/js'
import InputImage from '@iez/features/input-image/'
import Vue from 'vue'
import { reactive, computed, toRefs, ref } from '@vue/composition-api'
import initNativeCallback from '@iez/lib/init-native-callback/'

export default {
  props: {
    imageWidth: Number,
    imageHeight: Number,
    value: String,
    label: String,
    fillWidth: Boolean,
    hideDelete: Boolean,
    rules: {
      type: Array,
      default: () => []
    },
    rounded: Boolean
  },

  setup (props, { emit }) {
    const input = ref(null)

    const newValue = null // InputImage.resolve({ defaultValue: `` })
    if (newValue !== props.value) {
      emit(`input`, newValue)
    }

    const state = reactive({
      path: null,
      error: computed(() =>
        props.rules
          .map(rule => rule(state.model))
          .filter(
            value => value !== true
          )[0]
      ),
      previousModel: null,
      model: computed({
        get: () => props.value,
        set: value => {
          emit(`input`, value)
        }
      }),
      imagePlaceholderStyle: computed(() => ({
        ...props.fillWidth
          ? {
            width: `100%`,
            height: `100%`
          } : {
            width: `${props.imageWidth}px`,
            height: `${props.imageHeight}px`
          },
        border: `1px dashed rgba(0, 0, 0, 0.54)`,
        borderRadius: `12px`
      })),
      bindDirective: computed(
        () =>
          !state.image ? `image-input` : undefined
      )
    })

    const { callback: nativeSelectImage } = initNativeCallback({
      name: `selectImage`
    })

    const inputImage = async () => {
      if (!window.ReactNativeResponses) {
        input.value.$el.querySelector(`input`).click()
      } else {
        const value = state.previousModel ?? props.value
        const { image, previousImage, savedPath } = await nativeSelectImage({
          ...props.imageWidth
            ? {
              width: props.imageWidth,
              height: props.imageHeight
            } : null,
          value: value?.startsWith(`#`)
            ? null
            : value,
          savedPath: state.path
        })
        if (image) {
          state.model = image
          state.path = savedPath
          if (props.value) {
            state.previousModel = previousImage
          }
        }
      }
      /* state.model = InputImage.unmountToPromise({
        imageWidth: props.imageWidth,
        imageHeight: props.imageHeight,
        oversampling: 2,
        image: state.model,
        label: props.label
      }) */
    }

    return {
      mdiImagePlus,
      inputImage,
      ...toRefs(state),
      input,
      onChange: () => {
        const reader = new FileReader()
        reader.onload = ({ target: { result } }) => {
          state.model = result
        }
        const file = input.value.$el.querySelector(`input`).files[0]
        reader.readAsDataURL(file)

        // state.model = (new FileReader())
      }
    }
  }
}
</script>